<template>
    <div v-if="loading_cnh === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <input v-model="cnh.pf_cnh" id="cnh_numero" type="text">
          <label for="cnh_numero">Número</label>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="cnh.pf_cnh_cat" id="cnh_categoria">
            <option v-bind:value="null" selected>Selecione</option>
            <option v-for="(cat, i) in meta.cnh_cat" v-bind:key="i" v-bind:value="i">{{ cat}}</option>
          </select>
          <label for="cnh_categoria">Categoria</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="cnh.pf_cnh_validade" v-mask="['##/##/####']" id="cnh_dt_validade" type="text">
          <label for="cnh_dt_validade">Data de Validade</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="cnh.pf_cnh_emissao" v-mask="['##/##/####']" id="cnh_dt_emissao" type="text">
          <label for="cnh_dt_emissao">Data de Emissão</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="cnh.pf_cnh_prim_hab" v-mask="['##/##/####']" id="cnh_dt_permissao" type="text">
          <label for="cnh_dt_permissao">Data de Permissão</label>
        </div>
        <!-- 
        <div class="input-field col s12 m6">
          <input v-model="cnh.cnh_localidade" type="text" id="cnh_localidade" class="autocomplete" autocomplete="none">
          <label for="cnh_localidade">Localidade</label>
        </div> 
        -->
        <div class="input-field col s12">
          <textarea v-model="cnh.pf_cnh_obs" maxlength="35" id="cnh_obs" class="materialize-textarea"></textarea>
          <label for="cnh_obs">Observações</label>
        </div>
        <div class="input-field col s12 m12">
          <button @click="prepareSubmitCnh" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'CNH',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_cnh: false,
      meta: this.$store.state.meta.data,
      cnh: {
        pf_cnh: this.doc.cnh,
        pf_cnh_validade: (verificaData(this.doc.validade, 'YYYY-MM-DD') === true ? converteData(this.doc.validade) : null),
        pf_cnh_prim_hab: (verificaData(this.doc.primeira_habilitacao, 'YYYY-MM-DD') === true ? converteData(this.doc.primeira_habilitacao) : null),
        pf_cnh_cat: this.doc.categoria,
        pf_cnh_obs: this.doc.observacao,
        pf_cnh_emissao: (verificaData(this.doc.emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.emissao) : null),
        cidade_id: 0,
      },
      error_fields: {},
      loaded: null,      
    }
  },
  computed: {
    verificaForm: function() {
        let status = (
            Object.keys(this.cnh).filter(k => ['pf_cnh_obs', 'cidade_id'].includes(k) === false).filter((k) => this.cnh[k] && this.cnh[k] != '').length >= 5
            &&
            (verificaData(this.cnh.pf_cnh_validade) === true && verificaData(this.cnh.pf_cnh_prim_hab) === true && verificaData(this.cnh.pf_cnh_emissao) === true)
        )
        this.$emit('statusChange', {
          doc: 3,
          status: status
        })
        return status
    }
  },
  methods: {
    async submitInsertCnh(cnh){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cnh/`, {
        ...cnh,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_cnh = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 2)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_cnh = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitCnh(){
      this.loading_cnh = true
      let a = this.cnh //Atual

      let cnh = {
        pf_id: this.pf_id,
        pf_cnh: this.cnh.pf_cnh,
        pf_cnh_validade: (verificaData(this.cnh.pf_cnh_validade, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_validade) : null),
        pf_cnh_prim_hab: (verificaData(this.cnh.pf_cnh_prim_hab, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_prim_hab) : null),
        pf_cnh_cat: this.cnh.pf_cnh_cat,
        pf_cnh_obs: ( (this.cnh.pf_cnh_obs === "" || this.cnh.pf_cnh_obs === null) ? "" : this.cnh.pf_cnh_obs ),
        pf_cnh_emissao: (verificaData(this.cnh.pf_cnh_emissao, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_emissao) : null),
        cidade_id: 0,
      }

      if(this.loaded !== sha1(JSON.stringify(cnh))){
        return this.submitInsertCnh(cnh)
      } else {
        this.loading_cnh = false
        this.$emit('docSaved', 2)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
        pf_id: this.pf_id,
        pf_cnh: this.cnh.pf_cnh,
        pf_cnh_validade: (verificaData(this.cnh.pf_cnh_validade, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_validade) : null),
        pf_cnh_prim_hab: (verificaData(this.cnh.pf_cnh_prim_hab, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_prim_hab) : null),
        pf_cnh_cat: this.cnh.pf_cnh_cat,
        pf_cnh_obs: this.cnh.pf_cnh_obs,
        pf_cnh_emissao: (verificaData(this.cnh.pf_cnh_emissao, 'YYYY-MM-DD') === true ? formataData(this.cnh.pf_cnh_emissao) : null),
        cidade_id: 0
    }))
    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/CNH.vue